import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResourceDetails } from '../../model/resource-model';
import { Store } from '@ngrx/store';
import { GetResourceDetailRequest } from '../../core/resources-hub.actions';
import { getResourceDetails } from '../../core/resources-hub.selectors';
import { pluck, Subject, takeUntil } from "rxjs"
import { ActivatedRoute, Router } from "@angular/router";
import { profile } from "../../../../shared/core/shared.selectors";
import { roles } from "../../../../shared/constants/common.constants";
import { CommonService } from "../../../../shared/services/common.service";

@Component({
  selector: 'app-view-resource-screen',
  templateUrl: './view-resource-screen.component.html',
  styleUrls: ['./view-resource-screen.component.css']
})
export class ViewResourceScreenComponent implements OnInit, OnDestroy {
  resourceDetails: ResourceDetails = {};
  mode: 'preview' | 'view' = 'view'
  loggedInUserRole: number = null;
  allRoles = roles;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    if (this.router.url.includes('preview-resource')) {
      this.mode = 'preview'
    }
    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params.params.resourceId) {
          this.store.dispatch(GetResourceDetailRequest({
            payload: {
              resourceId: params.params.resourceId,
              slug: params.params.slug
            }
          }));
        }
      })
    this.store.select(getResourceDetails).pipe(takeUntil(this.onDestroy))
      .subscribe(resourceDetails => {
        this.resourceDetails = resourceDetails
      })

    this.store.select(profile).pipe()
      .pipe(takeUntil(this.onDestroy), pluck('role'))
      .subscribe(role => {
        this.loggedInUserRole = role
      });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams,
        }
        const prevUrlParams = this.commonService.urlParams.getValue();

        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  editButtonClickHandler() {
    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`/${urlPrefix}/resource-hub/edit-resource/${this.resourceDetails.id}/${this.resourceDetails.slug}`])
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
